import { ArrowLeft, Home } from "lucide-react";
import type React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";

const Unauthorized: React.FC = () => {
	const navigate = useNavigate();

	return (
		<div className="flex min-h-[70vh] items-center justify-center">
			<Card className="max-w-[500px] p-8 text-center">
				<div className="mb-5 text-6xl">🔒</div>
				<h1 className="mb-4 text-(--color-foreground)">Admin Only</h1>
				<p className="mb-8 text-(--color-muted-foreground)">
					This page is for administrators only. If you need access, please
					contact your MoneyGram representative.
				</p>
				<div className="flex flex-wrap justify-center gap-3">
					<Button onClick={() => navigate("/")}>
						<Home size={16} />
						Go to Dashboard
					</Button>
					<Button variant="outline" onClick={() => navigate(-1)}>
						<ArrowLeft size={16} />
						Go Back
					</Button>
				</div>
			</Card>
		</div>
	);
};

export default Unauthorized;
